module.exports = __webpack_public_path__ + "static/media/invoice-focus-grey-bg.50ca27ab.svg";